import product01 from "../assets/products/product01.webp"
import product02 from "../assets/products/product02.webp"
import product03 from "../assets/products/product03.webp"
import product04 from "../assets/products/product04.webp"
import product05 from "../assets/products/product05.webp"
import product06 from "../assets/products/product06.webp"
import product07 from "../assets/products/product07.webp"
import product08 from "../assets/products/product08.webp"

import popular01 from "../assets/popular/popular01.webp"
import popular02 from "../assets/popular/popular02.webp"
import popular03 from "../assets/popular/popular03.webp"
import popular04 from "../assets/popular/popular04.webp"
import popular05 from "../assets/popular/popular05.webp"
import popular06 from "../assets/popular/popular06.webp"
import popular07 from "../assets/popular/popular07.webp"
import popular08 from "../assets/popular/popular08.webp"

import new01 from "../assets/newIn/new01.webp"
import new02 from "../assets/newIn/new02.webp"
import new03 from "../assets/newIn/new03.webp"
import new04 from "../assets/newIn/new04.webp"
import new05 from "../assets/newIn/new05.webp"
import new06 from "../assets/newIn/new06.webp"
import new07 from "../assets/newIn/new07.webp"
import new08 from "../assets/newIn/new08.webp"

export const productData = [
    {
        image: product01,
        color: "241,241,241",
        brand: "Crocs",
        name: "Crocs x Salehe Bembury Pollex Clog Horchata",
        price: "187,000"
    },
    {
        image: product02,
        color: "230,236,242",
        brand: "Nike",
        name: "Nike Mac Attack QS SP Light Smoke Grey",
        price: "170,000"
    },
    {
        image: product03,
        color: "241,241,241",
        brand: "Adidas",
        name: "(W) Adidas Gazelle Indoor Bliss Pink",
        price: "194,000"
    },
    {
        image: product04,
        color: "237,238,229",
        brand: "Nos Couleurs",
        name: "Nos Couleurs Washed Film Jersey T-Shirt White",
        price: "155,000"
    },
    {
        image: product05,
        color: "230,236,242",
        brand: "Nike",
        name: "Nike x Jacquemus J Force 1 Low LX SP White",
        price: "188,000"
    },
    {
        image: product06,
        color: "230,236,242",
        brand: "Nike",
        name: "Nike x Jacquemus J Force 1 Low LX SP Black",
        price: "221,000"
    },
    {
        image: product07,
        color: "215,216,229",
        brand: "Nike",
        name: "Nike x Jacquemus J Force 1 Low LX SP White",
        price: "188,000"
    },
    {
        image: product08,
        color: "242,242,242",
        brand: "Adder Error",
        name: "Ader Error Shopper Bag AirPods Pro Case Z-Blue",
        price: "88,000"
    }
]


export const popularData = [
    {
      image: popular01,
      color: "241,241,241",
      brand: "Jordan",
      name: "Jordan 1 x Travis Scott Retro Low OG SP Sail and Ridgerock",
      price: "1,380,000",
    },
    {
      image: popular02,
      color: "230,236,242",
      brand: "Apple",
      name: "Apple AirPods Max Space Gray (Korean Ver.)",
      price: "645,000",
    },
    {
      image: popular03,
      color: "241,241,241",
      brand: "Apple",
      name: "Apple iPhone 14 Pro 128GB Space Black (Korean Ver.)",
      price: "1,353,000",
    },
    {
      image: popular04,
      color: "237,238,229",
      brand: "Apple",
      name: "Apple AirPods Max Silver (Korean Ver.)",
      price: "698,000원",
    },
    {
      image: popular05,
      color: "230,236,242",
      brand: "Apple",
      name: "Apple AirPods Pro 2nd Gen (Korean Ver.)",
      price: "303,000",
    },
    {
      image: popular06,
      color: "230,236,242",
      brand: "Jordan",
      name: "Jordan 1 High 85 Black White",
      price: "270,000",
    },
    {
      image: popular07,
      color: "215,216,229",
      brand: "Apple",
      name: "Apple iPad Air 5th Gen Wifi 64GB Space Gray (Korean Ver.)",
      price: "746,000",
    },
    {
      image: popular08,
      color: "242,242,242",
      brand: "Nike",
      name: "Nike V2K Run Summit White Metallic Silver",
      price: "178,000",
    },
  ];

export const newInData = [
  {
    image: new01,
    brand: "Jansport",
    name: "Jansport Half Pint Mini Backpack Loden Frost",
    price: "73,000"
  },
  {
    image: new02,
    brand: "Baracuta",
    name: "Baracuta G9 Harrington Jacket Natural",
    price: "359,000"
  },
  {
    image: new03,
    brand: "Laarvee",
    name: "Laarvee PEA001 Sliver Precision Steel Black Bezel Black Dial",
    price: "2,100,000"
  },
  {
    image: new04,
    brand: "The Museum Visitor",
    name: "[Pre-Order] The Museum Visitor Star Damaged Denim Half Shirts Light Blue",
    price: "184,500"
  },
  {
    image: new05,
    brand: "Salomon",
    name: "Salomon Trailblazer 20 Black",
    price: "95,000"
  },
  {
    image: new06,
    brand: "Hysteric Glamour",
    name: "Hysteric Glamour x P.A.M Alien Girl Mesh Cap Black",
  },
  {
    image: new07,
    brand: "Damiani",
    name: "Damiani Belle Epoque Diamonds Necklace White Gold",
    price: "9,690,000"
  },
  {
    image: new08,
    brand: "Bulgari",
    name: "Bulgari Divas Dream Necklace Rose Gold Mother of Pearl Diamond",
    price: "2,849,000"
  },
]